// Initialize Sentry first (must be before any other imports)
import '../../common-assets/js/components/sentry_init';

/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file (app.css in this case)
import '../../common-assets/styles/external/jquery-ui.min.css';
import '../../common-assets/styles/external/colorbox.css';
import '../../common-assets/styles/colorbox-class.css';
import '../../common-assets/js/external/jquery.colorbox-1.6.4.js';

import { commonUtils } from '../../common-assets/js/components/common_utils';
import { counters } from '../../common-assets/js/components/counters';
import { almaTunnus, almaTunnusLogin } from '../../common-assets/js/components/alma_tunnus';
import { accessibility } from '../../common-assets/js/accessibility';
import { searchFormStorage } from '../../common-assets/js/components/search/search_form_storage';
import { initEventDelegation } from '../../common-assets/js/components/event_delegation';

import routes from '../public/js/fos_js_routes.json';
import Routing from '../public/bundles/fosjsrouting/js/router.min';

global.commonUtils = commonUtils;
global.counters = counters;
global.almaTunnusLogin = almaTunnusLogin;
globalThis.almaTunnus = almaTunnus;
global.accessibility = accessibility;
globalThis.searchFormStorage = searchFormStorage;

Routing.setRoutingData(routes);
Routing.setBaseUrl(window.location.origin);
Routing.setLocale(commonUtils.getCurrentLocale());
global.Routing = Routing;

// init basic common events
$(function () {
    commonUtils.init();
    accessibility.init();
    initEventDelegation();

    // Clean up searched data from indexedDB if its expired
    searchFormStorage.cleanupOldDatabases();
});
